import { IconWithText } from 'common/icon/icon-with-text.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';

export const MobileModuleTitle = ({ title, iconName }: Pick<IModuleConfig, 'title' | 'iconName'>) => {
  const titleEl = (
    <p data-comp="render-title" className="small u-textBold u-mT-0 u-mB-0">
      {title}
    </p>
  );
  if (iconName) {
    return (
      <IconWithText icon={iconName} classes="svg--fill-inherit IconWithText--vCenter IconWithText--small">
        {titleEl}
      </IconWithText>
    );
  }
  return titleEl;
};
